import { useRef, useEffect, useMemo } from 'react';

import StaticdataApi from '@lcsc-ui/apis/staticdata';
import useUserStore from '@lcsc-ui/store/user';
import ecpCurl, { setContext, asyncAll } from '@lcsc-ui/utils/ecpCurl';
import Utils from '@lcsc-ui/utils/Utils';
import { NextSeo } from 'next-seo';

import API from '@/apis/item';
import { testExternal } from '@/utils/tools';

export default function DetailPDF({ webData, resourceData, pageUrl }) {
  const { updateProjectConfigVO } = useUserStore();

  const projectConfigVO = resourceData?.projectConfigVO;
  const productRecord = webData?.productRecord;
  const fileTypeVOList = productRecord?.fileTypeVOList;

  const showType = [
    'pdf_property',
    'certification_data_property',
    'industry_information',
    'reference_designs_property',
  ];
  const pdfUrl = fileTypeVOList?.filter((item) => showType.includes(item.fileType))[0]?.detailVOList?.[0]?.fileUrl;
  const isSouGou = useRef({});

  const url = projectConfigVO?.lcscAttaUrl + pdfUrl + '#page=1&view=fitH';

  const seo = useMemo(() => {
    const { productRecord, currentCatalog } = webData;
    return {
      title: `${productRecord?.productModel} -PDF数据手册-参考资料-立创商城`,
      description: `立创商城提供 ${productRecord?.productGradePlateName} 的 ${currentCatalog?.catalogName} ${productRecord?.productModel} 的PDF数据手册和参考资料，查看 ${productRecord?.productModel} 数据手册和购买 ${productRecord?.productModel} 上立创商城。`,
      additionalMetaTags: [
        {
          name: 'keywords',
          content: `${productRecord?.productModel}，${productRecord?.productModel} PDF数据手册,${productRecord?.productModel} 参考资料，立创商城`,
        },
      ],
      additionalLinkTags: [
        {
          rel: 'canonical',
          href: pageUrl,
        },
      ],
    };
  }, [webData, pageUrl]);

  const mobileRedirect = () => {
    if (Utils.isMobile()) {
      window.location.href = `https://static.szlcsc.com/ecp/assets/app/generic/web/viewer.html?file=${url}`;
    }
  };

  useEffect(() => {
    updateProjectConfigVO(resourceData?.projectConfigVO);
  }, [webData, resourceData]);

  useEffect(() => {
    isSouGou.current = testExternal(/sogou/);
    mobileRedirect();
  }, []);

  const PdfEl = (
    <div className="flex w-[100%]">
      <div className="flex-1">
        {isSouGou.current ? (
          <embed id="myPdfIframeSougou" src={url} frameborder="0" className="w-[100%] h-[100vh]"></embed>
        ) : (
          <iframe id="myPdfIframe" src={url} frameborder="0" className="w-[100%] h-[100vh]"></iframe>
        )}
      </div>
    </div>
  );

  return (
    <>
      <NextSeo {...seo}></NextSeo>
      {PdfEl}
    </>
  );
}

export async function getServerSideProps(context) {
  setContext(context);
  const { params } = context;
  const itemId = params.catalogId.replace('.html', '');

  if (!itemId) {
    return {
      notFound: true,
    };
  }

  const [webData, resourceData, notFound] = await asyncAll([
    ecpCurl(`${API.itemServe}${itemId}`),
    ecpCurl(`${StaticdataApi.resourceList}`, { enableCache: true }),
  ]);

  if (notFound) {
    return {
      notFound: true,
    };
  }

  const pageUrl = `${resourceData?.projectConfigVO?.lcscItemUrl}/datasheet/${params?.productModel}/${params?.catalogId}`;

  // 删除敏感数据,防止爬虫抓取
  delete webData?.productRecord?.productPriceList;
  delete webData?.productRecord?.productPriceDiscountList;
  delete webData?.productRecord?.entireProductPriceList;

  return {
    props: {
      webData,
      resourceData,
      pageUrl,
    },
  };
}
